export const isFuture = (date: string | Date, delay = 0) => {
  if (date instanceof Date) {
    return Date.now() < date.getTime();
  }

  const time = new Date(date).getTime();

  if (isNaN(time)) {
    throw new Error("Invalid date");
  }

  return Date.now() < time + delay;
};

// Expands a 2-digit card year to a full 4-digit year using the current century.
// e.g. "25" → "2025", "05" → "2005"
export const expandCardYear = (shortYear: string): string =>
  String(Math.floor(new Date().getFullYear() / 100) * 100 + parseInt(shortYear, 10));

// Splits a MM/YY validThru string into month and full 4-digit year.
// Returns empty strings for missing parts.
export const parseValidThru = (validThru: string): { month: string; year: string } => {
  const [month = "", shortYear = ""] = validThru.split("/");
  return { month, year: shortYear ? expandCardYear(shortYear) : "" };
};
